export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";